import React from "react";
import GridView from "./Grid/GridView.js";
import ListView from "./List/ListView.js";
import { useMailView } from "../../../contexts/mailViewContext/mailViewContext.js";

const FilesContainer = () => {
  const { getGridView } = useMailView();
  return getGridView() ? <GridView /> : <ListView />;
};

export default FilesContainer;
